import classNames from 'clsx';
import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import StarsButton from '@swf/components/StarsButton/StarsButton';
import type { ModalContextValue } from '@swf/components/StarsModal/Context';
import { ModalContext } from '@swf/components/StarsModal/Context';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';
import { useHomeGamesWidget, useWidgetTheme } from '@swf/poker';

import { TXTCLI_OK } from './Success.messages.json';
import styles from './Success.scss';

interface Props {
  title: React.ReactNode;
  text: React.ReactNode;
  imageClassName: string;
}

const Success: React.FC<Props> = ({ title, text, imageClassName = '' }) => {
  const {
    state: { widgetId }
  } = useLocation<{ widgetId: string }>();
  const { modal } = useDispatch<Dispatch>();
  const { setStyle } = useContext<ModalContextValue>(ModalContext);
  const language = useSelector(select.locale.get);
  const { widgetDispatch } = useHomeGamesWidget(widgetId);
  const { className } = useWidgetTheme();

  useEffect(() => {
    setStyle({
      overlayClassName: className,
      className: styles.successModal,
      closeOnOverlayClick: true,
      closeOnEsc: true
    });
  }, [className, setStyle]);

  useEffect(
    () => () => {
      widgetDispatch.fetchLobbyData();
    },
    [language, widgetDispatch]
  );

  return (
    <div className={styles.container}>
      <div className={classNames(styles.imageContainer, imageClassName)} />
      <div className={styles.content}>
        <h3>{title}</h3>
        <p>{text}</p>
        <StarsButton
          onClick={() => modal.close()}
          className={styles.button}
          translation={TXTCLI_OK}
        />
      </div>
    </div>
  );
};

export default Success;
